export const PRE_LOGIN_LOADING_STATES = {
    SIGN_IN_PAGE_LOADING: "SIGN_IN_PAGE_LOADING",
    SIGN_IN_PAGE_READY: "SIGN_IN_PAGE_READY",
    SSO_SIGN_IN_PAGE_LOADING: "SSO_SIGN_IN_PAGE_LOADING",
    SSO_SIGN_IN_PAGE_READY: "SSO_SIGN_IN_PAGE_READY",
    SIGN_UP_PAGE_LOADING: "SIGN_UP_PAGE_LOADING",
    SIGN_UP_PAGE_READY: "SIGN_UP_PAGE_READY",
    SSO_SIGN_UP_PAGE_LOADING: "SSO_SIGN_UP_PAGE_LOADING",
    SSO_SIGN_UP_PAGE_READY: "SSO_SIGN_UP_PAGE_READY",
    FORGOT_PASSWORD_PAGE_LOADING: "FORGOT_PASSWORD_PAGE_LOADING",
    FORGOT_PASSWORD_PAGE_READY: "FORGOT_PASSWORD_PAGE_READY",
    SET_PASSWORD_PAGE_LOADING: "SET_PASSWORD_PAGE_LOADING",
    SET_PASSWORD_PAGE_READY: "SET_PASSWORD_PAGE_READY",
    MEMBER_LOGIN_PAGE_LOADING: "MEMBER_LOGIN_PAGE_LOADING",
    MEMBER_LOGIN_PAGE_READY: "MEMBER_LOGIN_PAGE_READY",
}

export const PRE_LOGIN_STATES_MESSAGE_MAP = {
    [PRE_LOGIN_LOADING_STATES.SIGN_IN_PAGE_LOADING]: "Signing in",
    [PRE_LOGIN_LOADING_STATES.SIGN_UP_PAGE_LOADING]: "Signing up",
    [PRE_LOGIN_LOADING_STATES.SSO_SIGN_IN_PAGE_LOADING]: "Signing in",
    [PRE_LOGIN_LOADING_STATES.SSO_SIGN_UP_PAGE_LOADING]: "Signing up",
    [PRE_LOGIN_LOADING_STATES.FORGOT_PASSWORD_PAGE_LOADING]: "",
    [PRE_LOGIN_LOADING_STATES.SET_PASSWORD_PAGE_LOADING]: "",
    [PRE_LOGIN_LOADING_STATES.MEMBER_LOGIN_PAGE_LOADING]: "",
}

export const REDIRECT_TO = "redirectto"

export const SSO_TEXTS = {
    SIGNIN_TEXT: "SIGNIN",
    SIGNUP_TEXT: "SIGNUP",

    GOOGLE_TEXT: "google",
    APPLE_TEXT: "apple",
}